import { CableIcon, MonitorIcon, RadioTowerIcon, SatelliteDishIcon, ServerIcon, SplitIcon } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

export type Module = {
  number: string;
  title: string;
  summary: string;
  icon: LucideIcon;
};

export const modules: Module[] = [
  {
    number: '01',
    title: 'Fiber Optic Fundamentals: Fiber Types, Fusion Splicing, Connectors, OTDR & Testing',
    summary: 'A visual technical reference to how light travels through fiber, from fiber types and cables to fusion splicing, clean connectors, loss budgets and OTDR testing.',
    icon: CableIcon,
  },
  {
    number: '02',
    title: 'Structured Cabling Systems: Copper & Fiber, Racks, Pathways, Testing & Documentation',
    summary: 'A visual technical reference to cabling subsystems, twisted-pair categories, terminations, racks, pathways, fiber polarity, testing and labelling.',
    icon: ServerIcon,
  },
  {
    number: '03',
    title: 'FTTH & PON Access Networks: GPON, XGS-PON, Splitters, ODN Design & Installation',
    summary: 'A visual technical reference to PON architecture, splitters, wavelengths, power budgets, ODN design, drop installation and PON troubleshooting.',
    icon: SplitIcon,
  },
  {
    number: '04',
    title: 'Radio Links & Microwave Transmission: Propagation, Antennas, Link Budgets & Alignment',
    summary: 'A visual technical reference to microwave bands, antennas, line of sight, Fresnel zones, link budgets, fade margin, installation and alignment.',
    icon: SatelliteDishIcon,
  },
  {
    number: '05',
    title: 'Towers & Cellular Sites: Site Types, RAN Equipment, Antennas, Power, Grounding & Installation',
    summary: 'A visual technical reference to cell-site types, RAN architecture, sector antennas, feeders, DC power and batteries, grounding and installation quality.',
    icon: RadioTowerIcon,
  },
  {
    number: '06',
    title: 'Network Operations & Maintenance: NOC, Fault Management, Preventive Maintenance & Troubleshooting',
    summary: 'A visual technical reference to NOC operations, alarms and KPIs, availability, incident management, fiber-cut response, preventive maintenance and systematic troubleshooting.',
    icon: MonitorIcon,
  },
];
